<template>
  <div class='app'>
    <header class="app__header"><Header/></header>
    <div class="app__loader"><Loader/></div>
    <div class="app__alert"><Alert/></div>
    <main class="app__main">
      <router-view />
    </main>
  </div>
</template>

<script>
import Header
    from './views/Header'
import Loader
    from './views/Loader'
import Alert
    from './views/Alert'

window.current_api_version = '6.3';

export default {
  name: 'App',
  components: {
    Header,
    Loader,
    Alert,
  },
  created: function() {
    this.$api.beforeRequest = (config) => {
      if (config.url && config.url.search('logout') === -1)
        this.$$.load();
    }
    this.$api.onResponsed = (response) => {
      if (response.data.meta.api_version &&
              window.current_api_version < response.data.meta.api_version)
      {
        this.$$.alert({
          message: '新しいバージョンのアプリが見つかりました。アプリを読み込み直します。',
          actionText: '再読み込み',
          action: () => {
            window.navigator.serviceWorker.getRegistrations()
                .then(registrations => {
                  for(let registration of registrations) {
                    registration.unregister();
                  }
                });
            setTimeout(function() {window.location.reload(true)}, 1000);
          },
        });
      } else {
        this.$$.endload();
      }
    }
    this.$api.onResponseError = (err) => {
      this.$$.endload();
      let message = 'ネットワーク接続が不安定の為、ページを再読み込みをお願いします。',
          action = () => {};
      if (err.response) {
        message = err.response.data.message;
        switch (err.response.status) {
          case 401:
            this.$api.removeToken();
            message = "セッションの有効期限が切れました。もう一度ログインしてください。";
            action  = () => {this.$router.push({name: 'login'})};
            break;
          case 500:
            message = "サーバ内部エラー";
            break;
        }   
      }
      this.$$.alert({message: message, action: action});
    }
    this.$api.onTokenSetted = () => {
      if (this.$route.name === 'login') {
        let lastPath = localStorage.getItem('last_path')
        if (lastPath) {
          localStorage.removeItem('last_path')
          window.location.href = lastPath
        }
        else
          this.$router.push({name: 'orders'})
      }
    }
    this.$api.onTokenSetFailed = () => {
      localStorage.setItem('last_path', window.location.href);
      this.$router.push({name: 'login'})
    }
    this.$api.setToken();
  }
}
</script>

<style lang='scss'>
@import '@/style.scss';
.app {
  height: 100%;
  padding-top: 56px;
  position: relative;
  max-width: 800px;
  margin: auto;
  &__header {
    border-bottom: 1px solid #ddd;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  &__main {
    clear: both;
    height: 100%;
    overflow-x: hidden;
  }
  &__loader {
    position: absolute;
    bottom: 30%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }
  &__botnav {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
